<style lang="scss" src='./CourseUserList.scss' scoped></style>
<template src="./CourseUserList.html"></template>

<script>
  import Vue from 'vue';
  import { findUserByUsernameOrEmail, saveUserGolfCourse, deleteUserGolfCourse, getAllUsers, hideUser, markUserAsContact } from '@/api/index';
  import { mapMutations, mapState } from 'vuex';

  let usersArray = [];

  export default {
    name: 'CourseUserList',
    components: {
    },

    data() {
      return {
        username: null,
        loading: {
          addingUser: false,
        },
        selectedUsers: []
      };
    },

    computed: {
      usersSorted:function() {
        return this.G_sortArr(this.usersSetup, 'name');
      },
      usersFilter:function(){
        if(this.username){
          let username = this.username.toLowerCase();
          return usersArray.filter(
            (user) => 
              (user.username && user.username.toLowerCase().includes(username))  
              || (user.email && user.email.toLowerCase().includes(username)) 
              || (user.name && user.name.toLowerCase().includes(username))
            );
        }
        return usersArray;
      },
      ...mapState('CourseSetup', {
        usersSetup: (state) => state.setupData.users,
        course: (state) => state.setupData.course,
      }),
    },

    methods: {
      isSelected(user){
        return this.selectedUsers.find(u => u.user_id == user.user_id)
      },

      
      isGroundWorxUser(type){
        if(type == this.consts.UserGroup.GROUNDWORX){
          return true;
        }
        return false;
      },

      async addAnExistingUser() {
        if (this.selectedUsers.length > 0) {
          this.loading.addingUser = true;
          await this.selectedUsers.map((user)=>{
            findUserByUsernameOrEmail(user.username).then(async (user) => {
              const userAlreadyAdded = this.usersSetup.find(u => u.user_id == user.user_id);
              if (!userAlreadyAdded) {
                await this.saveUser(user);
              }
            })
          });

          this.selectedUsers = [];
          this.$bvModal.hide('md-add-existing-user');
          this.loading.addingUser = false;
        }
      },

      async saveUser(user) {
        if (this.course && this.course.course_id) {
          await saveUserGolfCourse(this.course.course_id, user.user_id).then(() => {
            if(user.user_type.group == this.consts.UserGroup.GROUNDWORX){
              user.hidden = true;
            }else{
              user.hidden = false;
            }
            this.addUser(user);
          });
        } else {
          if(user.user_type.group == this.consts.UserGroup.GROUNDWORX){
            user.hidden = true;
          }else{
            user.hidden = false;
          }
          this.addUser(user);
        }
      },
      
      goToAddNewUser() {
        this.setUserSelected(null);
        this.setEditingUser(false);
        this.setShowNewUserPage(true);
      },

      editUser(index) {
        const user = this.usersSorted[index];
        this.setUserSelected(user);
        this.setEditingUser(true);
        this.setShowNewUserPage(true);
      },

      selectUsername(user){
        let find = this.selectedUsers.findIndex(u => u.user_id == user.user_id)

        if(find == -1){
          this.selectedUsers.push(user)
        } else {
          this.selectedUsers.splice(find, 1);
        }
      },

      deleteUserFromCourse(index) {
        if (this.course && this.course.course_id) {
          const user = this.usersSorted[index];
          this.G_Alert_v2({ style: this.consts.Style.DANGER, 
                            message: this.$t('courses.delUserConfirm'),
                            fnOk: () => {
                              deleteUserGolfCourse(this.course.course_id, user.user_id)
                              .then(() => {
                                this.deleteUser(index);
                              });
                            }
                          });
        } else {
          this.deleteUser(index);
        }
      },

      loadAllUsers() {
        getAllUsers().then((response) => {
          if (response && response.users) {
            usersArray = response.users;
          }
        })
      },
      
      loadData() {
        this.setUserSelected(null);
        if (this.$store.state.user.user_type.type_id == this.consts.UserType.ADMIN ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.OPERATIONS){
          this.loadAllUsers()
        }
      },

      confirmHideUser (user){
        if(user.user_type.group != this.consts.UserGroup.GROUNDWORX){
          if(this.course && this.course.course_id){
            this.G_Alert_v2({ style: this.consts.Style.DANGER, 
              message: user.hidden 
                ? this.$t('users.dyrwToShow') 
                : this.$t('users.dyrwToHide') ,
              fnOk: () => {
                var hidden = !user.hidden;
                hideUser(user.user_id, this.course.course_id, hidden).then((resp) => {
                  user.hidden = hidden;
                });
              }
            });
          }
        }
      },

      confirmUserContact (user){
        if(this.course && this.course.course_id){
          this.G_Alert_v2({ style: this.consts.Style.DANGER, 
            message: user.contact
              ? this.$t('users.dyrwToNotContact') 
              : this.$t('users.dyrwToContact') ,
            fnOk: () => {
              var contact = !user.contact;
              markUserAsContact(user.user_id, this.course.course_id, contact).then((resp) => {
                user.contact = contact;
              });
            }
          });
        }
      },
  
      ...mapMutations('CourseSetup', ['setShowNewUserPage', 'addUser', 'deleteUser', 'setUserSelected', 'setEditingUser', 'setSetupData']),
    },

    mounted() {
      this.loadData();
    },

    beforeDestroy() {
    },
  };

</script>
